// アクティブタブ情報
export const tab = {
  strict: process.env.NODE_ENV === 'local',
  namespaced: true,
  state: {
    cabinetListActiveTab: 0,
    offerListActiveTab: 0,
    masterListActiveTab: 0,
    masterListStatusTab: 0,
    contractListTab: 0,
    reviewTab: 0
  },
  getters: {
    cabinetListActiveTab: state => state.cabinetListActiveTab,
    offerListActiveTab: state => state.offerListActiveTab,
    masterListActiveTab: state => state.masterListActiveTab,
    masterListStatusTab: state => state.masterListStatusTab,
    contractListTab: state => state.contractListTab,
    reviewTab: state => state.reviewTab
  },
  mutations: {
    setCabinetListActiveTab(state, payload) {
      state.cabinetListActiveTab = payload.activeTab;
    },
    setOfferListActiveTab(state, payload) {
      state.offerListActiveTab = payload.activeTab;
    },
    setMasterListActiveTab(state, payload) {
      state.masterListActiveTab = payload.activeTab;
    },
    setMasterListStatusTab(state, payload) {
      state.masterListStatusTab = payload.activeTab;
    },
    setContractListTab(state, payload) {
      state.contractListTab = payload.activeTab;
    },
    setReviewTab(state, payload) {
      state.reviewTab = payload.activeTab;
    }
  },
  actions: {
    /**
     * キャビネットのアクティブタブを保存
     */
    setCabinetListActiveTab(context, payload) {
      context.commit('setCabinetListActiveTab', {
        activeTab: payload.activeTab
      });
    },
    /**
     * 契約書作成・登録一覧のアクティブタブを保存
     */
    setOfferListActiveTab(context, payload) {
      context.commit('setOfferListActiveTab', {
        activeTab: payload.activeTab
      });
    },
    /**
     * 管理一覧のアクティブタブを保存
     */
    setMasterListActiveTab(context, payload) {
      context.commit('setMasterListActiveTab', {
        activeTab: payload.activeTab
      });
    },
    /**
     * 管理一覧内のステータス一覧のアクティブタブを保存
     */
    setMasterListStatusTab(context, payload) {
      context.commit('setMasterListStatusTab', {
        activeTab: payload.activeTab
      });
    },
    /**
     * 契約書一覧のアクティブタブを保存
     */
    setContractListTab(context, payload) {
      context.commit('setContractListTab', {
        activeTab: payload.activeTab
      });
    },
    /**
     * レビュー画面のアクティブタブを保存
     */
    setReviewTab(context, payload) {
      context.commit('setReviewTab', {
        activeTab: payload.activeTab
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/tab.js